// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom

// const AdmBookBarcode = () => {
//   const [rows, setRows] = useState([{ id: 1 }]); // State to manage rows
//   const navigate = useNavigate(); // Initialize navigate function

//   const handleClear = () => {
//     console.log("Clear button clicked");
//   };

//   const handleCloseModal = () => {
//     console.log("Close button clicked");
//   };

//   const handleOpenModal = () => {
//     console.log("Open modal button clicked");
//   };

//   const handleAddRow = () => {
//     const newRow = { id: rows.length + 1 }; // Generate a new row with a unique id
//     setRows([...rows, newRow]); // Add the new row to the state
//   };

//   // Function to handle navigation to the "/admin/book" page
//   const handleNavigateToBookPage = () => {
//     navigate("/admin/book");
//   };

//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12">
//           <div className="card p-0">
//             <div className="card-body">
//               <p
//                 style={{
//                   marginBottom: "0px",
//                   textAlign: "center",
//                   fontSize: "20px",
//                   fontWeight: "700",
//                 }}
//               >
//                 BOOK BARCODE
//               </p>

//               {/* Button Group */}
//               <div className="row mb-4">
//                 <div
//                   className="col-12"
//                   style={{ border: "1px solid #ccc", padding: "10px" }}
//                 >
//                   <button
//                     type="button"
//                     className="btn btn-primary me-2"
//                     style={{
//                       "--bs-btn-padding-y": ".25rem",
//                       "--bs-btn-padding-x": ".5rem",
//                       "--bs-btn-font-size": ".75rem",
//                       width: "150px",
//                     }}
//                   >
//                     Generate Barcode
//                   </button>

//                   <button
//                     type="button"
//                     className="btn btn-primary me-2"
//                     style={{
//                       "--bs-btn-padding-y": ".25rem",
//                       "--bs-btn-padding-x": ".5rem",
//                       "--bs-btn-font-size": ".75rem",
//                       width: "150px",
//                     }}
//                     onClick={handleClear}
//                   >
//                     Clear
//                   </button>

//                   <button
//                     type="button"
//                     className="btn btn-primary me-2"
//                     style={{
//                       "--bs-btn-padding-y": ".25rem",
//                       "--bs-btn-padding-x": ".5rem",
//                       "--bs-btn-font-size": ".75rem",
//                       width: "150px",
//                     }}
//                     onClick={handleCloseModal}
//                   >
//                     Close
//                   </button>
//                 </div>
//               </div>

//               {/* Responsive Table with Input Fields */}
//               <div className="row">
//                 <div className="col-12">
//                   <div className="table-responsive">
//                     <table className="table table-bordered table-striped">
//                       <thead>
//                         <tr>
//                           <th>Sr No</th>
//                           <th>Book Code</th>
//                           <th>Book Name</th>
//                           <th>Book Accession No</th>
//                           <th>Category</th>
//                           <th>Sub-Category</th>
//                           <th>Delete</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {rows.map((row, index) => (
//                           <tr key={row.id}>
//                             <td>{index + 1}</td>
//                             <td>
//                               <div>
//                                 <input
//                                   type="text"
//                                   className="form-control"
//                                   placeholder="Enter Book Code"
//                                 />
//                                 <button
//                                   type="button"
//                                   className="btn btn-primary ms-2 mb-0 mt-2"
//                                   style={{
//                                     "--bs-btn-padding-y": ".2rem",
//                                     "--bs-btn-padding-x": ".4rem",
//                                     "--bs-btn-font-size": ".6rem",
//                                     width: "35px",
//                                     height: "30px",
//                                   }}
//                                   onClick={handleNavigateToBookPage} // Use the navigate function here
//                                 >
//                                   ...
//                                 </button>
//                               </div>
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Book Name"
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Accession No"
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Category"
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Sub-Category"
//                               />
//                             </td>
//                             <td>
//                               <button className="btn btn-danger btn-sm">
//                                 Delete
//                               </button>
//                             </td>
//                           </tr>
//                         ))}
//                         {/* Add New Row Button Row */}
//                         <tr>
//                           <td colSpan="6" className="text-end">
//                             <button
//                               type="button"
//                               className="btn btn-success"
//                               onClick={handleAddRow}
//                             >
//                               Add New Row
//                             </button>
//                           </td>
//                           <td></td> {/* Empty cell for Delete column */}
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdmBookBarcode;

////recent correct  code///

// import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import AdmBook from "./AdmBook";

// import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom

// const AdmBookBarcode = () => {
//   const [rows, setRows] = useState([{ id: 1 }]);
//   const [showModal, setShowModal] = useState(false); // State for modal visibility
//    const [selectedRowId, setSelectedRowId] = useState(null);
//  // // State to manage rows
//   const navigate = useNavigate(); // Initialize navigate function

//   const handleClear = () => {
//     console.log("Clear button clicked");
//   };

//   const handleCloseModal = () => {
//     setShowModal(false); // Close the modal
//   };

//    const handleOpenModal = (rowId) => {
//      setSelectedRowId(rowId);
//      setShowModal(true);
//    };
//   const handleAddRow = () => {
//     const newRow = { id: rows.length + 1 }; // Generate a new row with a unique id
//     setRows([...rows, newRow]); // Add the new row to the state
//   };

//   // Function to handle navigation to the "/admin/book" page
//   // const handleNavigateToBookPage = () => {
//   //   navigate("/admin/book");
//   // };
// const handleBookSelection = (selectedBook) => {
//   // Extract the relevant details from selectedBook
//   const { id, bookCode, bookName, barcode, categoryName, subcategoryName } =
//     selectedBook;

//   // Update the row with selected book details using selectedRowId
//   setRows((prevRows) =>
//     prevRows.map((row) =>
//       row.id === selectedRowId
//         ? {
//             ...row,
//             bookCode: bookCode || "", // Set default values in case any field is missing
//             bookName: bookName || "",
//             barcode: barcode || "",
//             categoryName: categoryName || "",
//             subcategoryName: subcategoryName || "",
//           }
//         : row
//     )
//   );
//   setShowModal(false); // Close modal after selection
// };
// // const handleBarcodeChange = async (e, rowId) => {
// //   const enteredBarcode = e.target.value;

// //   try {
// //     const response = await fetch(
// //       `${ApiUrl.apiurl}LIBRARYBOOK/GetAllBooksDetails`
// //     );
// //     const data = await response.json();

// //     if (data.message === "success" && Array.isArray(data.data)) {
// //       const matchedBook = data.data.find(
// //         (book) => book.barcode === enteredBarcode
// //       );

// //       setRows((prevRows) =>
// //         prevRows.map((row) =>
// //           row.id === rowId
// //             ? {
// //                 ...row,
// //                 barcode: enteredBarcode,
// //                 bookCode: matchedBook ? matchedBook.bookCode : "",
// //                 bookName: matchedBook ? matchedBook.bookName : "",
// //                 categoryName: matchedBook ? matchedBook.categoryName : "",
// //                 subcategoryName: matchedBook ? matchedBook.subcategoryName : "",
// //               }
// //             : row
// //         )
// //       );
// //     }
// //   } catch (error) {
// //     console.error("Error fetching book data:", error);
// //   }
// // };


// const handleBarcodeChange = async (e, rowId) => {
//   const enteredBarcode = e.target.value;

//   // Update barcode field while typing
//   setRows((prevRows) =>
//     prevRows.map((row) =>
//       row.id === rowId ? { ...row, barcode: enteredBarcode } : row
//     )
//   );

//   if (enteredBarcode.trim() === "") return; // Prevent API call if input is empty

//   try {
//     // Dynamically call the API with the barcode number
//     const response = await fetch(
//       `${ApiUrl.apiurl}LIBRARYBOOK/GetAllBooksDetails?barcodeNo=${enteredBarcode}`
//     );
//     const data = await response.json();

//     if (data.message === "success" && data.data && data.data.length > 0) {
//       const matchedBook = data.data[0]; // Assuming the response data contains a single book object

//       if (matchedBook) {
//         // Update the row with fetched book data
//         setRows((prevRows) =>
//           prevRows.map((row) =>
//             row.id === rowId
//               ? {
//                   ...row,
//                   barcode: matchedBook.barcode || enteredBarcode,
//                   bookCode: matchedBook.bookCode || "",
//                   bookName: matchedBook.bookName || "",
//                   categoryName: matchedBook.categoryName || "",
//                   subcategoryName: matchedBook.subcategoryName || "",
//                 }
//               : row
//           )
//         );
//       }
//     }
//   } catch (error) {
//     console.error("Error fetching book data:", error);
//   }
// };






//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12">
//           <div className="card p-0">
//             <div className="card-body">
//               <p
//                 style={{
//                   marginBottom: "0px",
//                   textAlign: "center",
//                   fontSize: "20px",
//                   fontWeight: "700",
//                 }}
//               >
//                 BOOK BARCODE
//               </p>

//               {/* Button Group */}
//               <div className="row mb-4">
//                 <div
//                   className="col-12"
//                   style={{ border: "1px solid #ccc", padding: "10px" }}
//                 >
//                   <button
//                     type="button"
//                     className="btn btn-primary me-2"
//                     style={{
//                       "--bs-btn-padding-y": ".25rem",
//                       "--bs-btn-padding-x": ".5rem",
//                       "--bs-btn-font-size": ".75rem",
//                       width: "150px",
//                     }}
//                   >
//                     Generate Barcode
//                   </button>

//                   <button
//                     type="button"
//                     className="btn btn-primary me-2"
//                     style={{
//                       "--bs-btn-padding-y": ".25rem",
//                       "--bs-btn-padding-x": ".5rem",
//                       "--bs-btn-font-size": ".75rem",
//                       width: "150px",
//                     }}
//                     onClick={handleClear}
//                   >
//                     Clear
//                   </button>

//                   <button
//                     type="button"
//                     className="btn btn-primary me-2"
//                     style={{
//                       "--bs-btn-padding-y": ".25rem",
//                       "--bs-btn-padding-x": ".5rem",
//                       "--bs-btn-font-size": ".75rem",
//                       width: "150px",
//                     }}
//                     onClick={handleCloseModal}
//                   >
//                     Close
//                   </button>
//                 </div>
//               </div>

//               {/* Responsive Table with Input Fields */}
//               <div className="row">
//                 <div className="col-12">
//                   <div className="table-responsive">
//                     <table className="table table-bordered table-striped">
//                       <thead>
//                         <tr>
//                           <th>Sr No</th>
//                           <th>Book Code</th>
//                           <th>Book Name</th>
//                           <th>Book Accession No</th>
//                           <th>Category</th>
//                           <th>Sub-Category</th>
//                           <th>Delete</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {rows.map((row, index) => (
//                           <tr key={row.id}>
//                             <td>{index + 1}</td>
//                             <td>
//                               <div>
//                                 <input
//                                   type="text"
//                                   className="form-control"
//                                   placeholder="Enter Book Code"
//                                   value={row.bookCode || ""}
//                                   readOnly
//                                 />
//                                 <button
//                                   type="button"
//                                   className="btn btn-primary ms-2 mb-0 mt-2"
//                                   style={{
//                                     "--bs-btn-padding-y": ".2rem",
//                                     "--bs-btn-padding-x": ".4rem",
//                                     "--bs-btn-font-size": ".6rem",
//                                     width: "35px",
//                                     height: "30px",
//                                   }}
//                                   onClick={() => handleOpenModal(row.id)} // Open modal on button click // Use the navigate function here
//                                 >
//                                   ...
//                                 </button>

//                                 <AdmBook
//                                   show={showModal}
//                                   handleClose={handleCloseModal}
//                                   selectedRowId={selectedRowId}
//                                   onSelectBook={handleBookSelection}
//                                 />
//                               </div>
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Book Name"
//                                 value={row.bookName || ""}
//                                 readOnly
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Accession No"
//                                 value={row.barcode || ""}
//                                 onChange={(e) => handleBarcodeChange(e, row.id)}
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Category"
//                                 value={row.categoryName || ""}
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Sub-Category"
//                                 value={row.subcategoryName || ""}
//                               />
//                             </td>
//                             <td>
//                               <a href="#" className="text-danger">
//                                 Delete
//                               </a>
//                             </td>
//                           </tr>
//                         ))}
//                         {/* Add New Row Button Row */}
//                         <tr>
//                           <td colSpan="6" className="text-end">
//                             <button
//                               type="button"
//                               className="btn btn-success"
//                               onClick={handleAddRow}
//                             >
//                               Add New Row
//                             </button>
//                           </td>
//                           <td></td> {/* Empty cell for Delete column */}
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdmBookBarcode;



// import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import AdmBook from "./AdmBook";
// import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom

// import JsBarcode from "jsbarcode";
// import { jsPDF } from "jspdf";

// const AdmBookBarcode = () => {
//   // Initialize with 5 rows
//   const [rows, setRows] = useState(
//     Array.from({ length: 6 }, (_, index) => ({ id: index + 1 }))
//   );
//   const [showModal, setShowModal] = useState(false); // State for modal visibility
//   const [selectedRowId, setSelectedRowId] = useState(null);
//   const navigate = useNavigate(); // Initialize navigate function

//   const handleClear = () => {
//     console.log("Clear button clicked");
//   };

//   const handleCloseModal = () => {
//     setShowModal(false); // Close the modal
//   };

//   const handleOpenModal = (rowId) => {
//     setSelectedRowId(rowId);
//     setShowModal(true);
//   };

//   const handleAddRow = () => {
//     const newRow = { id: rows.length + 1 }; // Generate a new row with a unique id
//     setRows([...rows, newRow]); // Add the new row to the state
//   };

//   const handleBookSelection = (selectedBook) => {
//     const { id, bookCode, bookName, barcode, categoryName, subcategoryName } = selectedBook;

//     setRows((prevRows) =>
//       prevRows.map((row) =>
//         row.id === selectedRowId
//           ? {
//               ...row,
//               bookCode: bookCode || "",
//               bookName: bookName || "",
//               barcode: barcode || "",
//               categoryName: categoryName || "",
//               subcategoryName: subcategoryName || "",
//             }
//           : row
//       )
//     );
//     setShowModal(false); // Close modal after selection
//   };

//   const handleBarcodeChange = async (e, rowId) => {
//     const enteredBarcode = e.target.value;

//     // Update barcode field while typing
//     setRows((prevRows) =>
//       prevRows.map((row) =>
//         row.id === rowId ? { ...row, barcode: enteredBarcode } : row
//       )
//     );

//     if (enteredBarcode.trim() === "") return; // Prevent API call if input is empty

//     try {
//       const response = await fetch(
//         `${ApiUrl.apiurl}LIBRARYBOOK/GetAllBooksDetails?barcodeNo=${enteredBarcode}`
//       );
//       const data = await response.json();

//       if (data.message === "success" && data.data && data.data.length > 0) {
//         const matchedBook = data.data[0]; // Assuming the response data contains a single book object

//         if (matchedBook) {
//           setRows((prevRows) =>
//             prevRows.map((row) =>
//               row.id === rowId
//                 ? {
//                     ...row,
//                     barcode: matchedBook.barcode || enteredBarcode,
//                     bookCode: matchedBook.bookCode || "",
//                     bookName: matchedBook.bookName || "",
//                     categoryName: matchedBook.categoryName || "",
//                     subcategoryName: matchedBook.subcategoryName || "",
//                   }
//                 : row
//             )
//           );
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching book data:", error);
//     }
//   };
// // const generateBarcode = () => {
// //   const barcodeNumbers = rows
// //     .map((row) => (row.barcode ? String(row.barcode).trim() : "")) // Ensure barcode is a string
// //     .filter((barcode) => barcode !== ""); // Remove empty values

// //   if (barcodeNumbers.length === 0) {
// //     alert(
// //       "No barcode numbers available to generate. Please enter barcode numbers."
// //     );
// //     return;
// //   }

// //   const newWindow = window.open("", "_blank", "width=400,height=300");
// //   if (newWindow) {
// //     newWindow.document.write(`
// //       <html>
// //         <head>
// //           <title>Generated Barcode</title>
// //           <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.0/dist/JsBarcode.all.min.js"></script>
// //         </head>
// //         <body style="text-align:center; margin-top:50px;">
// //           ${barcodeNumbers
// //             .map(
// //               (barcode, index) => `
// //             <div>
// //               <svg id="barcode-${index}"></svg>
// //               <p style="font-size: 20px; font-weight: bold;">${barcode}</p>
// //             </div>
// //           `
// //             )
// //             .join("")}
// //           <script>
// //             window.onload = function() {
// //               ${barcodeNumbers
// //                 .map(
// //                   (barcode, index) => `
// //                 JsBarcode("#barcode-${index}", "${barcode}", {
// //                   format: "CODE128",
// //                   displayValue: true,
// //                   fontSize: 16
// //                 });
// //               `
// //                 )
// //                 .join("")}
// //             };
// //           </script>
// //         </body>
// //       </html>
// //     `);
// //   }
// // };



// const generateBarcode = () => {
//   const barcodeNumbers = rows
//     .map((row) => (row.barcode ? String(row.barcode).trim() : "")) // Ensure barcode is a string
//     .filter((barcode) => barcode !== ""); // Remove empty values

//   if (barcodeNumbers.length === 0) {
//     alert("No barcode numbers available. Please enter barcode numbers.");
//     return;
//   }

//   const newWindow = window.open("", "_blank", "width=600,height=400");
//   if (newWindow) {
//     newWindow.document.write(`
//       <html>
//         <head>
//           <title>Generated Barcode</title>
//           <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.0/dist/JsBarcode.all.min.js"></script>
//         </head>
//         <body style="text-align:center; margin-top:50px;">
//           ${barcodeNumbers
//             .map(
//               (barcode, index) => `
//             <div style="margin-bottom: 20px;">
//               <svg id="barcode-${index}"></svg>
//             </div>
//           `
//             )
//             .join("")}
//           <script>
//             window.onload = function() {
//               ${barcodeNumbers
//                 .map(
//                   (barcode, index) => `
//                 JsBarcode("#barcode-${index}", "${barcode}", {
//                   format: "CODE128",
//                   displayValue: true,  // Show the value below the barcode
//                   lineColor: "#000",
//                   width: 2,
//                   height: 50
//                 });
//               `
//                 )
//                 .join("")}
//             };
//           </script>
//         </body>
//       </html>
//     `);

//     // Ensure the JS barcode library is loaded and the barcode is rendered
//     newWindow.document.close(); // Close the document to allow script execution
//   }
// };

// const handleDeleteRow = (rowId) => {
//   setRows((prevRows) =>
//     prevRows.map((row) =>
//       row.id === rowId
//         ? {
//             ...row,
//             bookCode: "",
//             bookName: "",
//             barcode: "",
//             categoryName: "",
//             subcategoryName: "",
//           }
//         : row
//     )
//   );
// };






//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12">
//           <div className="card p-0">
//             <div className="card-body">
//               <p
//                 style={{
//                   marginBottom: "0px",
//                   textAlign: "center",
//                   fontSize: "20px",
//                   fontWeight: "700",
//                 }}
//               >
//                 BOOK BARCODE
//               </p>

//               {/* Button Group */}
              // <div className="row mb-4">
              //   <div
              //     className="col-12"
              //     style={{ border: "1px solid #ccc", padding: "10px" }}
              //   >
              //     <button
              //       type="button"
              //       className="btn btn-primary me-2"
              //       style={{
              //         "--bs-btn-padding-y": ".25rem",
              //         "--bs-btn-padding-x": ".5rem",
              //         "--bs-btn-font-size": ".75rem",
              //         width: "150px",
              //       }}
              //       onClick={generateBarcode}
              //     >
              //       Generate Barcode
              //     </button>

              //     <button
              //       type="button"
              //       className="btn btn-primary me-2"
              //       style={{
              //         "--bs-btn-padding-y": ".25rem",
              //         "--bs-btn-padding-x": ".5rem",
              //         "--bs-btn-font-size": ".75rem",
              //         width: "150px",
              //       }}
              //       onClick={handleClear}
              //     >
              //       Clear
              //     </button>

              //     <button
              //       type="button"
              //       className="btn btn-primary me-2"
              //       style={{
              //         "--bs-btn-padding-y": ".25rem",
              //         "--bs-btn-padding-x": ".5rem",
              //         "--bs-btn-font-size": ".75rem",
              //         width: "150px",
              //       }}
              //       onClick={handleCloseModal}
              //     >
              //       Close
              //     </button>
              //   </div>
              // </div>

//               {/* Responsive Table with Input Fields */}
//               <div className="row">
//                 <div className="col-12">
//                   <div className="table-responsive">
//                     <table className="table table-bordered table-striped">
//                       <thead>
//                         <tr>
//                           <th>Sr No</th>
//                           <th>Book Code</th>
//                           <th>Book Name</th>
//                           <th>Book Accession No</th>
//                           <th>Category</th>
//                           <th>Sub-Category</th>
//                           <th>Delete</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {rows.map((row, index) => (
//                           <tr key={row.id}>
//                             <td>{index + 1}</td>
//                             <td>
//                               <div>
//                                 <input
//                                   type="text"
//                                   className="form-control"
//                                   placeholder="Enter Book Code"
//                                   value={row.bookCode || ""}
//                                   readOnly
//                                 />
//                                 <button
//                                   type="button"
//                                   className="btn btn-primary ms-2 mb-0 mt-2"
//                                   style={{
//                                     "--bs-btn-padding-y": ".2rem",
//                                     "--bs-btn-padding-x": ".4rem",
//                                     "--bs-btn-font-size": ".6rem",
//                                     width: "35px",
//                                     height: "30px",
//                                   }}
//                                   onClick={() => handleOpenModal(row.id)}
//                                 >
//                                   ...
//                                 </button>

//                                 <AdmBook
//                                   show={showModal}
//                                   handleClose={handleCloseModal}
//                                   selectedRowId={selectedRowId}
//                                   onSelectBook={handleBookSelection}
//                                 />
//                               </div>
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Book Name"
//                                 value={row.bookName || ""}
//                                 readOnly
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Accession No"
//                                 value={row.barcode || ""}
//                                 onChange={(e) => handleBarcodeChange(e, row.id)}
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Category"
//                                 value={row.categoryName || ""}
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Enter Sub-Category"
//                                 value={row.subcategoryName || ""}
//                               />
//                             </td>
//                             <td>
//                               <a
//                                 href="#"
//                                 className="text-danger"
//                                 onClick={() => handleDeleteRow(row.id)}
//                               >
//                                 Delete
//                               </a>
//                             </td>
//                           </tr>
//                         ))}
//                         {/* Add New Row Button Row */}
//                         <tr>
//                           <td colSpan="6" className="text-end">
//                             <button
//                               type="button"
//                               className="btn btn-success"
//                               onClick={handleAddRow}
//                             >
//                               Add New Row
//                             </button>
//                           </td>
//                           <td></td> {/* Empty cell for Delete column */}
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdmBookBarcode;


import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AdmBook from "./AdmBook";
import { useNavigate } from "react-router-dom";
import JsBarcode from "jsbarcode";
import jsPDF from "jspdf";
import { ApiUrl } from "../../../ApiUrl";
// import JsBarcode from "jsbarcode";


const AdmBookBarcode = () => {
  // const [rows, setRows] = useState(
  //   Array.from({ length: 6 }, (_, index) => ({ id: index + 1 }))
  // );

  const [rows, setRows] = useState(() =>
    Array.from({ length: 30 }, (_, index) => ({
      id: Date.now() + index, // unique id
      bookCode: "",
      bookName: "",
      barcode: "",
      categoryName: "",
      subcategoryName: "",
    }))
  );
  
  // const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const navigate = useNavigate();

  const handleClear = () => {
    setRows((prevRows) =>
      prevRows.map((row) => ({
        ...row,
        bookCode: "",
        bookName: "",
        barcode: "",
        categoryName: "",
        subcategoryName: "",
      }))
    );
  };
//  const handleAddRow = () => {
//    const newRow = {
//      id: rows.length + 1,
//      bookCode: "",
//      bookName: "",
//      barcode: "",
//      categoryName: "",
//      subcategoryName: "",
//    };
//    setRows([...rows, newRow]);
//  };

const handleAddRow = () => {
  setRows((prevRows) => [
    ...prevRows,
    {
      id: Date.now(), // unique id
      bookCode: "",
      bookName: "",
      barcode: "",
      categoryName: "",
      subcategoryName: "",
    },
  ]);
};


  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (rowId) => {
    setSelectedRowId(rowId);
    setShowModal(true);
  };

  const handleBookSelection = (selectedBook) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === selectedRowId
          ? {
              ...row,
              bookCode: selectedBook.bookCode || "",
              bookName: selectedBook.bookName || "",
              barcode: selectedBook.barcode || "",
              categoryName: selectedBook.categoryName || "",
              subcategoryName: selectedBook.subcategoryName || "",
            }
          : row
      )
    );
    setShowModal(false);
  };

  const handleBarcodeChange = async (e, rowId) => {
    const enteredBarcode = e.target.value;

    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === rowId ? { ...row, barcode: enteredBarcode } : row
      )
    );

    if (enteredBarcode.trim() === "") return;

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}LIBRARYBOOK/GetAllBooksDetails?barcodeNo=${enteredBarcode}`
      );
      const data = await response.json();

      if (data.message === "success" && data.data && data.data.length > 0) {
        const matchedBook = data.data[0];

        if (matchedBook) {
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.id === rowId
                ? {
                    ...row,
                    barcode: matchedBook.barcode || enteredBarcode,
                    bookCode: matchedBook.bookCode || "",
                    bookName: matchedBook.bookName || "",
                    categoryName: matchedBook.categoryName || "",
                    subcategoryName: matchedBook.subcategoryName || "",
                  }
                : row
            )
          );
        }
      }
    } catch (error) {
      console.error("Error fetching book data:", error);
    }
  };

  
  const generateBarcode = () => {
    const barcodeNumbers = rows
      .map((row) => (row.barcode ? String(row.barcode).trim() : ""))
      .filter((barcode) => barcode !== "");

    if (barcodeNumbers.length === 0) {
      alert("No barcode numbers available. Please enter barcode numbers.");
      return;
    }

    const pdf = new jsPDF();
    let yPos = 10;

    barcodeNumbers.forEach((barcode, index) => {
      const canvas = document.createElement("canvas");
      const width = 200;
      const height = 80;
      canvas.width = width;
      canvas.height = height;

      JsBarcode(canvas, barcode, {
        format: "CODE128",
        lineColor: "#000000",
        width: 2,
        height: 40,
        displayValue: true,
        fontOptions: "bold",
        font: "Arial",
        fontSize: 16,
        textMargin: 0,
        margin: 0,
      });

      const barcodeImage = canvas.toDataURL("image/png");
      const imgWidthMM = width * 0.264583;
      const imgHeightMM = height * 0.264583;

      pdf.addImage(barcodeImage, "PNG", 20, yPos, imgWidthMM, imgHeightMM);
      yPos += imgHeightMM + 5;

      if (index !== barcodeNumbers.length - 1 && yPos > 250) {
        pdf.addPage();
        yPos = 10;
      }
    });

    // Get blob URL and open in new tab
    const pdfUrl = pdf.output("bloburl");
    window.open(pdfUrl, "_blank");
  };
  
  
  
  
  // const handleDeleteRow = (rowId) => {
  //   setRows((prevRows) =>
  //     prevRows.map((row) =>
  //       row.id === rowId
  //         ? {
  //             ...row,
  //             bookCode: "",
  //             bookName: "",
  //             barcode: "",
  //             categoryName: "",
  //             subcategoryName: "",
  //           }
  //         : row
  //     )
  //   );
  // };

const handleDeleteRow = (rowId) => {
  setRows((prevRows) => prevRows.filter((row) => row.id !== rowId));
};

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p className="text-center fw-bold fs-5">BOOK BARCODE</p>

              {/* Button Group */}
              <div className="row mb-4">
                <div
                  className="col-12 d-flex flex-wrap gap-2"
                  // style={{ border: "1px solid #ccc", padding: "10px" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "170px",
                    }}
                    onClick={generateBarcode}
                  >
                    Generate Barcode
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* Table */}
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table table-bordered ">
                      <thead>
                        <tr>
                          <th>Sr No</th>
                          <th>Book Code</th>
                          <th>Book Name</th>
                          <th>Book Accession No</th>
                          <th>Category</th>
                          <th>Sub-Category</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, index) => (
                          <tr key={row.id}>
                            <td>{index + 1}</td>
                            <td>
                              <input
                                type="text"
                                className="form-control detail"
                                value={row.bookCode || ""}
                                readOnly
                              />
                              <button
                                className="btn btn-primary ms-2 mt-2"
                                style={{ width: "35px", height: "30px" }}
                                onClick={() => handleOpenModal(row.id)}
                              >
                                ...
                              </button>
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control detail"
                                value={row.bookName || ""}
                                readOnly
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control detail"
                                value={row.barcode || ""}
                                onChange={(e) => handleBarcodeChange(e, row.id)}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control detail"
                                value={row.categoryName || ""}
                                readOnly
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control detail"
                                value={row.subcategoryName || ""}
                                readOnly
                              />
                            </td>
                            <td>
                              <a
                                href="#"
                                className="text-danger"
                                onClick={() => handleDeleteRow(row.id)}
                              >
                                Delete
                              </a>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="7" className="text-end">
                            <button
                              className="btn btn-success"
                              onClick={handleAddRow}
                            >
                              Add New Row
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Single Modal Instance */}
              {showModal && (
                <AdmBook
                  show={showModal}
                  handleClose={handleCloseModal}
                  selectedRowId={selectedRowId}
                  onSelectBook={handleBookSelection}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmBookBarcode;

